import $ from "jquery";
import "what-input";

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
// require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import "./lib/foundation-explicit-pieces";
import "hc-sticky/dist/hc-sticky";
import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

$(document).foundation();

var engineUtils = {
  init: function () {
    this.ui.init();
  },

  ui: {
    init: function () {
      engineUtils.ui.layout();
      engineUtils.ui.plugins();
    },

    layout: function () {
      // Directions
      var directionVal =
        $("html").css("direction").toLowerCase() === "rtl" ? "rtl" : "ltr";

      var direction =
        $("html").css("direction").toLowerCase() === "rtl" ? "right" : "left";

      // Password Eye
      if ($(".form-field__input .icomoon-icon.icon-eye").length) {
        $(".form-field__input .icomoon-icon.icon-eye").on("click", function () {
          $(this).toggleClass("icon-eye");
          $(this).toggleClass("icon-eye-off");
          if ($(this).siblings("input").attr("type") == "password") {
            $(this).siblings("input").attr("type", "text");
          } else {
            $(this).siblings("input").attr("type", "password");
          }
        });
      }

      // Toggle Navpanel
      if (
        $(".navpanel").length &&
        Foundation.MediaQuery.is("small only") == true
      ) {
        $(".menu-toggle__btn, .nav__link").on("click", function () {
          $(".menu-toggle__btn").toggleClass("active");
          $(".navpanel").toggleClass("expanded");
        });

        $(".navpanel .nav__link").on("click", function () {
          $(".navpanel").removeClass("expanded");
        });
      }

      // Text Carousel
      if ($(".text-carousel").length) {
        var textCouroselSplide = new Splide(".text-carousel.splide", {
          arrows: false,
          pagination: true,
          perPage: 1,
          autoHeight: true,
          direction: directionVal,
          rewind: true,
        });
        textCouroselSplide.mount();

        $(".main-carousel__btn a").on("click", function () {
          textCouroselSplide.go("+1");
          return false;
        });
      }

      // Video Hero Carousel
      if ($(".video-hero-carousel").length) {
        var slideCount = $(".video-hero-carousel .splide__slide").length;
        var videoHeroCouroselSplide = new Splide(
          ".video-hero-carousel.splide",
          {
            arrows: false,
            pagination: true,
            drag: slideCount === 1 ? false : true,
            perPage: 1,
            autoHeight: true,
            direction: directionVal,
          },
        );
        videoHeroCouroselSplide.mount();
      }

      // Video
      if ($(".video").length) {
        $(".video").each(function () {
          // var $vidThumbnail = $(".video__img", this);
          // var $thumb = $(".video__play", this);
          var $vidWrapper = $(this);
          var $vidWrapperId = $(".video__src", this).attr("id");
          var $vidId = $(".video__src", this).data("videoId");
          var $vidThumb = $(".video__img").length ? $(".video__img", this) : "";
          var $vidPlay = $(".video__play").length
            ? $(".video__play", this)
            : "";
          var vidPlayer = jwplayer($vidWrapperId);

          var vidPlayerApi = "https://cdn.jwplayer.com/v2/media/" + $vidId;

          fetch(vidPlayerApi)
            .then((response) => response.json())
            .then((responseData) => {
              var videoData = responseData.playlist[0];
              var videoUrl = videoData.sources
                .filter((item) => item.type == "video/mp4")
                .slice(-1)[0].file;
              var videoImgUrl = videoData.images.slice(-1)[0].src;

              vidPlayer.setup({
                file: videoUrl,
                image: videoImgUrl,
                autostart: false,
                allowFullscreen: false,
                responsive: true,
              });

              if ($(".video__img").length) {
                vidPlayer.on("play", function () {
                  $($vidThumb).addClass("playing");
                  $($vidPlay).addClass("playing");
                  $($vidWrapper).addClass("playing");
                });

                vidPlayer.on("pause", function () {
                  $($vidThumb).removeClass("playing");
                  $($vidPlay).removeClass("playing");
                  $($vidWrapper).removeClass("playing");
                });

                $($vidPlay).on("click", function () {
                  vidPlayer.play();
                });
              }
            });
        });
      }

      // Video Carousel
      if ($(".video-hero-carousel").length) {
        $(".video-hero-carousel__item").each(function () {
          var $id = $(".video-hero-carousel__video", this).attr("id");
          var $thumbnail = $(".video-hero-carousel__img", this);
          var $content = $(".video-hero-carousel__content", this);
          var $thumb = $(".video-hero-carousel__play", this);
          var $videoWrapper = $(".video-hero-carousel__video-wrapper", this);
          var $videoId = $(".video-hero-carousel__video", this).attr(
            "data-video-id",
          );
          var $videoIdSm = $(".video-hero-carousel__video", this).attr(
            "data-video-id-sm",
          );
          var heroPlayer = jwplayer($id);
          var vRatio = "16:9";

          if (Foundation.MediaQuery.is("small only") == true) {
            vRatio = "9:16";
            $videoId = $videoIdSm;
          }

          var jwplayerApi = "https://cdn.jwplayer.com/v2/media/" + $videoId;

          fetch(jwplayerApi)
            .then((response) => response.json())
            .then((responseData) => {
              var videoData = responseData.playlist[0];
              var videoUrl = videoData.sources
                .filter((item) => item.type == "video/mp4")
                .slice(-1)[0].file;
              var videoImgUrl = videoData.images.slice(-1)[0].src;

              heroPlayer.setup({
                file: videoUrl,
                image: videoImgUrl,
                autostart: false,
                allowFullscreen: false,
                responsive: true,
                aspectratio: vRatio,
              });

              heroPlayer.on("play", function () {
                $($thumb).addClass("playing");
                $($content).addClass("playing");
                $($thumbnail).addClass("playing");
                $($videoWrapper).addClass("playing");
              });

              heroPlayer.on("pause", function () {
                $($thumb).removeClass("playing");
                $($content).removeClass("playing");
                $($thumbnail).removeClass("playing");
                $($videoWrapper).removeClass("playing");
              });

              heroPlayer.on("complete", function () {
                $($thumb).removeClass("playing");
                $($content).removeClass("playing");
                $($thumbnail).removeClass("playing");
                $($videoWrapper).removeClass("playing");
              });

              $($thumb).on("click", function () {
                heroPlayer.play();
              });
            });
        });
      }

      // text-list-carousel
      if ($(".text-list-carousel").length) {
        var textListCarouselSplide = new Splide(".text-list-carousel.splide", {
          arrows: false,
          pagination: true,
          perPage: 1,
          autoHeight: true,
          direction: directionVal,
        });
        textListCarouselSplide.mount();
      }

      // Partners Carousel
      if ($(".partners__carousel").length) {
        var partnerCarouselSplide = new Splide(
          ".partners__carousel--default.splide",
          {
            type: "loop",
            arrows: false,
            pagination: false,
            autoWidth: true,
            drag: "free",
            gap: "150px",
            focus: "center",
            direction: directionVal,
            autoScroll: {
              speed: 1,
              pauseOnHover: false,
              pauseOnFocus: false,
            },
            breakpoints: {
              640: {
                gap: "100px",
              },
            },
          },
        );

        try {
          partnerCarouselSplide.mount({ AutoScroll });
        } catch (error) {
          console.error("Splide row 1 initialization failed:", error);
        }

        var partnerCouroselReverseSpli = new Splide(
          ".partners__carousel--reverse.splide",
          {
            type: "loop",
            arrows: false,
            pagination: false,
            autoWidth: true,
            drag: "free",
            gap: "150px",
            focus: "center",
            direction: directionVal,
            autoScroll: {
              speed: -1,
              pauseOnHover: false,
              pauseOnFocus: false,
            },
            breakpoints: {
              640: {
                gap: "100px",
              },
            },
          },
        );

        try {
          partnerCouroselReverseSpli.mount({ AutoScroll });
        } catch (error) {
          console.error("Splide row 2 initialization failed:", error);
        }
      }

      // Instructor Carousel
      if ($(".instructor-carousel").length) {
        var opts = {};

        if (!$(".instructor-carousel--secondary").length) {
          opts = {
            arrows: false,
            pagination: true,
            perPage: 1,
            direction: directionVal,
          };
        } else {
          opts = {
            perPage: 3,
            gap: "23px",
            padding: { direction: "6rem" },
            arrows: false,
            direction: directionVal,

            breakpoints: {
              640: {
                destroy: "completely",
              },
            },
          };
        }

        var instructorCarouselSplide = new Splide(
          ".instructor-carousel.splide",
          opts,
          // {

          //   // arrows: false,
          //   // pagination: true,
          //   // perPage: 1,
          //   // direction: directionVal,
          // }
        );
        instructorCarouselSplide.mount();

        // if ($(".instructor-carousel--secondary").length) {
        //   instructorCarouselSplide.options = {
        //     perPage: 4,
        //     gap: "23px",
        //     type: "loop",
        //     padding: { right: "6rem" },

        //     breakpoints: {
        //       640: {
        //         destroy: "completely",
        //       },
        //     },
        //   };
        // }
      }

      // Testimonials Carousel
      if ($(".testimonial-carousel").length) {
        var testimonialCarouselSplide = new Splide(
          ".testimonial-carousel.splide",
          {
            arrows: true,
            pagination: false,
            perPage: 1,
            direction: directionVal,
            type: "loop",
          },
        );
        testimonialCarouselSplide.mount();
      }

      // News Carousel
      if ($(".newsroom__list").length) {
        var newsCarouselSplide = new Splide(".newsroom__list.splide", {
          arrows: true,
          pagination: false,
          perPage: 1,
          perMove: 1,
          start: 1,
          direction: directionVal,
          type: "loop",
        });

        var main = new Splide(".newsroom__view .splide", {
          type: "fade",
          arrows: true,
          drag: false,
          pagination: false,
          arrows: false,
        });

        newsCarouselSplide.mount();
        main.mount();
        newsCarouselSplide.on(
          "move",
          function (newIndex, prevIndex, destIndex) {
            main.go(prevIndex);
          },
        );
      }

      // News and Insight Carousel
      if ($(".news-insight-slider").length) {
        var newsInsightCouroselSplide = new Splide(
          ".news-insight-slider.splide",
          {
            arrows: true,
            pagination: false,
            perPage: 1,
            direction: directionVal,
          },
        );

        newsInsightCouroselSplide.mount();
        newsInsightCouroselSplide.on("move", function (newIndex) {
          $(".slide-count__index").text(newIndex + 1);
        });
        $(".custom-splide__arrow--prev").on("click", function () {
          newsInsightCouroselSplide.go("-1");
        });
        $(".custom-splide__arrow--next").on("click", function () {
          newsInsightCouroselSplide.go("+1");
        });
        $(".slide-count__total").text(
          $(".news-insight-slider__item.splide__slide").length,
        );
      }

      // News and Insight Carousel
      if ($(".bootcamp-slider").length) {
        var bootcampSplide = new Splide(".bootcamp-slider.splide", {
          arrows: false,
          pagination: true,
          perPage: 1,
          direction: directionVal,
        });

        bootcampSplide.mount();
      }

      // form file upload
      if ($(".file-upload").length) {
        const dropArea = document.querySelector(".file-upload"),
          dragText = dropArea.querySelector(".file-upload-name"),
          button = dropArea.querySelector(".custom-upload"),
          input = dropArea.querySelector("input[type=file]");
        let file;

        // $("input[type=file]").change(function (e) {
        //   $(this).parents(".file-upload").find(".file-upload-name").text(e.target.files[0].name);
        // });

        input.addEventListener("change", function (e) {
          //getting user select file and [0] this means if user select multiple files then we'll select only the first one
          file = this.files[0];
          dropArea.classList.add("active");
          showFile(e); //calling function
        });

        //If user Drag File Over DropArea
        dropArea.addEventListener("dragover", (event) => {
          event.preventDefault(); //preventing from default behaviour
          dropArea.classList.add("active");
          dragText.textContent = "Release to Upload File";
        });

        //If user leave dragged File from DropArea
        dropArea.addEventListener("dragleave", () => {
          dropArea.classList.remove("active");
          dragText.textContent = "Choose files or drag here";
        });

        //If user drop File on DropArea
        dropArea.addEventListener("drop", (event) => {
          event.preventDefault(); //preventing from default behaviour
          //getting user select file and [0] this means if user select multiple files then we'll select only the first one
          file = event.dataTransfer.files[0];
          showFile(); //calling function
        });

        function showFile(e) {
          let fileType = file.type; //getting selected file type
          let validExtensions = [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          ]; //adding some valid image extensions in array
          if (validExtensions.includes(fileType)) {
            //if user selected file is an image file
            let fileReader = new FileReader(); //creating new FileReader object
            fileReader.onload = () => {
              let fileURL = fileReader.result; //passing user file source in fileURL variable
              // for image view
              // let imgTag = `<img src="${fileURL}" alt="image">`; //creating an img tag and passing user selected file source inside src attribute
              // dropArea.innerHTML = imgTag; //adding that created img tag inside dropArea container
              dragText.textContent = file.name;
            };
            fileReader.readAsDataURL(file);
          } else {
            alert("This is not a PDF / Doc file!");
            dropArea.classList.remove("active");
            dragText.textContent = "Choose files or drag here";
          }
        }
      }

      if ($(".countdown").length) {
        const second = 1000,
          minute = second * 60,
          hour = minute * 60,
          day = hour * 24;

        const countDown = new Date("03/31/2024").getTime(),
          x = setInterval(function () {
            const now = new Date().getTime(),
              distance = countDown - now;

            ((document.getElementById("days").innerText = Math.floor(
              distance / day,
            )),
              (document.getElementById("hours").innerText = Math.floor(
                (distance % day) / hour,
              )),
              (document.getElementById("minutes").innerText = Math.floor(
                (distance % hour) / minute,
              )));

            //do something later when date is reached
            if (distance < 0) {
              clearInterval(x);
            }
            //seconds
          }, 0);
      }

      // mailchimp

      var mc1Submitted = false;
      $("#mc-embedded-subscribe-form").on("submit reset", function (event) {
        console.log(event);
        if ("submit" === event.type) {
          mc1Submitted = true;
        } else if ("reset" === event.type && mc1Submitted) {
          console.log("success");
          $("#successMailchimp").foundation("open");
        }
      });

      // waitlist slides

      if ($(".waitlist-target").length) {
        $(".btnNext").on("click", function () {
          console.log($("#step-" + $(this).attr("target")), "next");
          $(".waitlist-target").removeClass("active");
          $("#step-" + $(this).attr("target")).addClass("active");
        });
      }

      // View all focus areas
      if ($(".js-view-all-focus").length) {
        $(".js-view-all-focus").on("click", function (e) {
          e.preventDefault();
          var $hiddenItems = $(".card-catalogue-list__items--hidden");

          if ($hiddenItems.is(":visible")) {
            $hiddenItems.slideUp(400);
            $(this).text("View all");
          } else {
            $hiddenItems.slideDown(400);
            $(this).text("View less");
          }
        });
      }
    },

    plugins: function () {},
  },
};

$(document).ready(function () {
  engineUtils.init();
});
